// Shared helpers for describing an assignable item's DEFAULT due date in the
// assign modals, so a manager can see whether they need to set a custom one.
// Direct-assignment wrappers (and tracks with no due date) have no default.

export function formatDueDate(date) {
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/**
 * Human description of an item's default due date, or null if it has none.
 * `item` carries completion_due_date (YYYY-MM-DD) and/or
 * completion_due_days_after_enrollment (int, relative).
 *
 * The fixed-date-before-relative-days precedence here mirrors the canonical
 * rule in LearningTrackEnrollment.effective_due_date (and its ORM twin
 * effective_due_date_expression) in backend/lms_info/models/learning_track.py
 * — if that fallback chain changes, update this description too. This is a
 * display-only hint; enforcement is always the backend's.
 */
export function describeDefaultDueDate(item) {
  if (!item) return null;
  if (item.completion_due_date) {
    // Stored as YYYY-MM-DD; anchor to local midnight to avoid TZ drift.
    const fixed = new Date(`${item.completion_due_date}T00:00:00`);
    return `Due ${formatDueDate(fixed)} by default.`;
  }
  const days = item.completion_due_days_after_enrollment;
  if (days) {
    const approx = new Date();
    approx.setDate(approx.getDate() + days);
    return `Due ${days} day${days === 1 ? "" : "s"} after assigning (around ${formatDueDate(
      approx
    )}) by default.`;
  }
  return null;
}
